export type LeverageScore = 'High' | 'Medium' | 'Low';
export type LeadStatus = 'New' | 'Reviewed' | 'Contacted' | 'Won' | 'Rejected';

export interface Lead {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  projectType: string;
  budgetRange: string;
  timeline: string;
  priority: string;
  address: string;
  photoUrl: string;
  photoAlt: string;
  estimateMin: number;
  estimateMax: number;
  leverageScore: LeverageScore;
  scoreReason: string;
  status: LeadStatus;
  submittedAt: string;
  notes: string;
}

export const mockLeads: Lead[] = [
{
  id: 'lead-001',
  firstName: 'Marcus',
  lastName: 'Rivera',
  email: 'marcus.rivera@gmail.com',
  phone: '(512) 334-7821',
  projectType: 'Exterior Painting',
  budgetRange: '$5,000–$10,000',
  timeline: 'Within 1 week',
  priority: 'Must-have — I need this done',
  address: '4821 Barton Creek Blvd, Austin, TX 78735',
  photoUrl: "https://images.unsplash.com/photo-1612074302361-725535fa2c75",
  photoAlt: 'Two-story house exterior with peeling paint on white siding needing full repaint',
  estimateMin: 4800,
  estimateMax: 6200,
  leverageScore: 'High',
  scoreReason: 'High budget + urgent timeline — close this one fast',
  status: 'New',
  submittedAt: '2026-04-20T08:14:00Z',
  notes: 'HOA deadline approaching, needs to be done before May 1st'
},
{
  id: 'lead-002',
  firstName: 'Priya',
  lastName: 'Nair',
  email: 'priya.nair@outlook.com',
  phone: '(737) 891-2034',
  projectType: 'Interior Painting',
  budgetRange: '$2,000–$5,000',
  timeline: 'Within 2 weeks',
  priority: 'Must-have — I need this done',
  address: '1102 S Lamar Blvd, Austin, TX 78704',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1c6db1a99-1772187207560.png",
  photoAlt: 'Living room interior with scuffed beige walls and outdated paint needing refresh',
  estimateMin: 2100,
  estimateMax: 2900,
  leverageScore: 'High',
  scoreReason: 'High budget signals with urgent 2-week timeline',
  status: 'New',
  submittedAt: '2026-04-20T07:42:00Z',
  notes: 'Moving in on May 5th, needs to be ready before furniture arrives'
},
{
  id: 'lead-003',
  firstName: 'Derek',
  lastName: 'Thompson',
  email: 'derek.t@yahoo.com',
  phone: '(512) 778-3345',
  projectType: 'Pressure Washing',
  budgetRange: '$500–$2,000',
  timeline: 'Within a month',
  priority: 'Nice-to-have — depends on price',
  address: '308 W 6th St, Austin, TX 78701',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_11736cd29-1764672714247.png",
  photoAlt: 'Concrete driveway and patio covered in green mold and black staining needing pressure wash',
  estimateMin: 380,
  estimateMax: 520,
  leverageScore: 'Medium',
  scoreReason: 'Reasonable budget, month-long timeline — follow up next week',
  status: 'Reviewed',
  submittedAt: '2026-04-19T16:22:00Z',
  notes: ''
},
{
  id: 'lead-004',
  firstName: 'Aaliyah',
  lastName: 'Johnson',
  email: 'aaliyah.j@gmail.com',
  phone: '(512) 556-9901',
  projectType: 'Flooring Installation',
  budgetRange: '$5,000–$10,000',
  timeline: 'Within 2 weeks',
  priority: 'Must-have — I need this done',
  address: '7700 Shoal Creek Blvd, Austin, TX 78757',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1513592c3-1767601183392.png",
  photoAlt: 'Damaged hardwood floor with warped boards and scratches throughout open plan living space',
  estimateMin: 5200,
  estimateMax: 7100,
  leverageScore: 'High',
  scoreReason: 'Top budget bracket + urgent timeline + must-have priority',
  status: 'Contacted',
  submittedAt: '2026-04-19T11:08:00Z',
  notes: 'Water damage from burst pipe last week'
},
{
  id: 'lead-005',
  firstName: 'Carlos',
  lastName: 'Mendez',
  email: 'c.mendez@hotmail.com',
  phone: '(737) 204-8812',
  projectType: 'Drywall Repair',
  budgetRange: 'Under $500',
  timeline: 'Flexible / Just exploring',
  priority: 'Just exploring options',
  address: '2210 E Cesar Chavez St, Austin, TX 78702',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_15a46b473-1776653705260.png",
  photoAlt: 'Small drywall hole approximately 6 inches wide in white bedroom wall',
  estimateMin: 180,
  estimateMax: 260,
  leverageScore: 'Low',
  scoreReason: 'Low budget + flexible timeline — nurture sequence recommended',
  status: 'Reviewed',
  submittedAt: '2026-04-18T14:55:00Z',
  notes: ''
},
{
  id: 'lead-006',
  firstName: 'Simone',
  lastName: 'Laurent',
  email: 'simone.laurent@gmail.com',
  phone: '(512) 671-4430',
  projectType: 'Interior Painting',
  budgetRange: '$10,000+',
  timeline: 'Within 1 week',
  priority: 'Must-have — I need this done',
  address: '3800 Bee Cave Rd, West Lake Hills, TX 78746',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_123a3efef-1771900624571.png",
  photoAlt: 'Large luxury home open concept interior with high ceilings showing old paint throughout multiple rooms',
  estimateMin: 9800,
  estimateMax: 13500,
  leverageScore: 'High',
  scoreReason: 'Maximum budget bracket + urgent timeline — priority close',
  status: 'New',
  submittedAt: '2026-04-20T06:33:00Z',
  notes: 'Full home repaint, 4,800 sq ft, staging for sale listing next weekend'
},
{
  id: 'lead-007',
  firstName: 'James',
  lastName: 'Okafor',
  email: 'james.okafor@icloud.com',
  phone: '(512) 889-0023',
  projectType: 'General Handyman',
  budgetRange: '$500–$2,000',
  timeline: 'Within a month',
  priority: 'Nice-to-have — depends on price',
  address: '5500 Manor Rd, Austin, TX 78723',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1324e523d-1776653706431.png",
  photoAlt: 'Kitchen with broken cabinet doors, loose fixtures and worn countertop needing handyman repairs',
  estimateMin: 650,
  estimateMax: 950,
  leverageScore: 'Medium',
  scoreReason: 'Mid budget, flexible timeline — good fit for nurture email',
  status: 'New',
  submittedAt: '2026-04-18T09:17:00Z',
  notes: 'Multiple small repairs — cabinet doors, leaky faucet, broken towel bar'
},
{
  id: 'lead-008',
  firstName: 'Fatima',
  lastName: 'Hassan',
  email: 'fatima.h@gmail.com',
  phone: '(737) 312-6654',
  projectType: 'Exterior Painting',
  budgetRange: '$2,000–$5,000',
  timeline: 'Within a month',
  priority: 'Must-have — I need this done',
  address: '1234 N Loop 1 W, Austin, TX 78756',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_15c80e12c-1767919635542.png",
  photoAlt: 'Single story ranch home with faded brown exterior paint and visible wood rot on trim',
  estimateMin: 2800,
  estimateMax: 3800,
  leverageScore: 'Medium',
  scoreReason: 'Mid-high budget, must-have priority — schedule estimate call',
  status: 'Won',
  submittedAt: '2026-04-17T13:41:00Z',
  notes: 'Closed at $3,200. Job starts April 28.'
},
{
  id: 'lead-009',
  firstName: 'Tyler',
  lastName: 'Nguyen',
  email: 'tyler.nguyen@gmail.com',
  phone: '(512) 445-7788',
  projectType: 'Pressure Washing',
  budgetRange: 'Under $500',
  timeline: 'Flexible / Just exploring',
  priority: 'Just exploring options',
  address: '901 Red River St, Austin, TX 78701',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_11736cd29-1764672714247.png",
  photoAlt: 'Small concrete patio with light algae staining needing basic pressure wash',
  estimateMin: 120,
  estimateMax: 180,
  leverageScore: 'Low',
  scoreReason: 'Low budget, no urgency — not worth immediate follow-up',
  status: 'Rejected',
  submittedAt: '2026-04-17T10:05:00Z',
  notes: 'Price shopping, not ready to commit'
},
{
  id: 'lead-010',
  firstName: 'Brianna',
  lastName: 'Walker',
  email: 'brianna.w@outlook.com',
  phone: '(512) 234-9900',
  projectType: 'Flooring Installation',
  budgetRange: '$2,000–$5,000',
  timeline: 'Within 2 weeks',
  priority: 'Must-have — I need this done',
  address: '6001 Airport Blvd, Austin, TX 78752',
  photoUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1256a0b0c-1777076462232.png",
  photoAlt: 'Master bedroom with old carpet being replaced with new hardwood flooring halfway installed',
  estimateMin: 2400,
  estimateMax: 3200,
  leverageScore: 'High',
  scoreReason: 'Urgent timeline + must-have priority — respond today',
  status: 'Contacted',
  submittedAt: '2026-04-16T15:30:00Z',
  notes: 'Replacing carpet in 3 bedrooms with LVP'
}];


export const weeklyLeadData = [
{ day: 'Mon', leads: 4, high: 2, medium: 1, low: 1 },
{ day: 'Tue', leads: 7, high: 3, medium: 2, low: 2 },
{ day: 'Wed', leads: 3, high: 1, medium: 1, low: 1 },
{ day: 'Thu', leads: 9, high: 4, medium: 3, low: 2 },
{ day: 'Fri', leads: 6, high: 2, medium: 2, low: 2 },
{ day: 'Sat', leads: 5, high: 3, medium: 1, low: 1 },
{ day: 'Sun', leads: 2, high: 1, medium: 1, low: 0 }];


// ─── Scoring Utility ──────────────────────────────────────────────────────────
// Mirrors the server-side logic in /api/calculate-estimate so the dashboard
// can re-score any lead client-side without an extra network round-trip.

export interface ScoredLead {
  leverageScore: LeverageScore;
  scoreReason: string;
  scoreFactors: {
    budgetSignal: 'strong' | 'moderate' | 'weak';
    urgencySignal: 'high' | 'medium' | 'low';
    intentSignal: 'committed' | 'conditional' | 'browsing';
  };
}

export function scoreLead(lead: Pick<Lead, 'budgetRange' | 'timeline' | 'priority'>): ScoredLead {
  // Budget signal
  const strongBudgets = ['$2,000–$5,000', '$5,000–$10,000', '$10,000+'];
  const moderateBudgets = ['$500–$2,000'];
  const budgetSignal: 'strong' | 'moderate' | 'weak' = strongBudgets.includes(lead.budgetRange) ? 'strong' : moderateBudgets.includes(lead.budgetRange) ? 'moderate' : 'weak';

  // Urgency signal
  const highUrgency = ['Within 1 week', 'Within 2 weeks'];
  const mediumUrgency = ['Within a month'];
  const urgencySignal: 'high' | 'medium' | 'low' = highUrgency.includes(lead.timeline) ? 'high' : mediumUrgency.includes(lead.timeline) ? 'medium' : 'low';

  // Intent signal
  const intentSignal: 'committed' | 'conditional' | 'browsing' =
  lead.priority === 'Must-have — I need this done' ? 'committed' :
  lead.priority === 'Nice-to-have — depends on price' ? 'conditional' : 'browsing';

  // Score matrix
  let leverageScore: LeverageScore;
  let scoreReason: string;

  if (
  budgetSignal === 'strong' && urgencySignal === 'high' ||
  budgetSignal === 'strong' && intentSignal === 'committed')
  {
    leverageScore = 'High';
    scoreReason =
    budgetSignal === 'strong' && urgencySignal === 'high' ? 'High budget + urgent timeline — close this one fast' : 'High budget + committed intent — strong buying signal';
  } else if (
  budgetSignal === 'strong' ||
  budgetSignal === 'moderate' ||
  urgencySignal === 'high' && intentSignal !== 'browsing' ||
  urgencySignal === 'medium' && intentSignal === 'committed')
  {
    leverageScore = 'Medium';
    const reasons: string[] = [];
    if (budgetSignal === 'strong') reasons.push('strong budget');
    if (budgetSignal === 'moderate') reasons.push('moderate budget');
    if (urgencySignal === 'high') reasons.push('urgent timeline');
    if (intentSignal === 'committed') reasons.push('committed intent');
    scoreReason = `Good signals (${reasons.join(', ')}) — worth a follow-up call`;
  } else {
    leverageScore = 'Low';
    const reasons: string[] = [];
    if (budgetSignal === 'weak') reasons.push('low budget');
    if (urgencySignal === 'low') reasons.push('flexible timeline');
    if (intentSignal === 'browsing') reasons.push('just exploring');
    scoreReason = `Low urgency or budget signals (${reasons.join(', ')}) — nurture sequence recommended`;
  }

  return { leverageScore, scoreReason, scoreFactors: { budgetSignal, urgencySignal, intentSignal } };
}